export default {
  install (Vue, options) {

    const $tools = {
      isMobile () {
        return window.innerWidth <= 1024
      },

      isTouchDevice () {
        return (('ontouchstart' in window) ||
             ('ontouchstart' in document.documentElement) ||
             (navigator.MaxTouchPoints > 0) ||
             (navigator.msMaxTouchPoints > 0))
      },

      disableScroll()
      {
        let top = window.scrollY || document.documentElement.scrollTop
        console.log(top)
        document.body.style.top =  - top + 'px';
        document.body.style.position = 'fixed';
      },

      enableScroll() {
        const top = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(top || '0') * -1);
      },
    }

    Vue.prototype.$tools = $tools
    Vue.$tools = $tools
  }
}
